/*
 * File: 属地客户经理
 */
<template>
    <div>
        <div class="local-customer-manager-btn">
            <lots-button
                type="text"
                v-show="!tipText && hasAuth"
                icon="el-icon-circle-plus-outline"
                size="medium"
                @click="handleAdd"
            >新增</lots-button>
            <span class="local-customer-manager-tip" v-show="tipText">{{ tipText }}</span>
        </div>
        <edit-table-box
            ref="editTableBox"
            v-loading="managerList.tableLoading"
            :key="rendertable"
            :index="config.index"
            :selection="config.selection"
            :columns="config.columns"
            :height="config.height"
            :tableData="managerList.totalData"
            :actions="config.actions || {}"
            :control="!tipText && hasAuth"
            :rowEdit="config.rowEdit"
            :allowRowClick="false"
            :allowRowClickFunc="config.rowDbClickFun"
            :editDisableRule="config.disableEditFun"
            @element-change="handleChangeRow"
            @btn-event="handleActive"
        >
            <template #col-append="{item, row}">
                <!-- 用户状态 -->
                <span v-if="item.prop === 'localManagerStatus'">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}</span>
            </template>
            <template #edit-col-append="{ item, row }">
                <!-- 用户状态 -->
                <span v-if="item.prop === 'localManagerStatus'">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey])}}</span>
            </template>
        </edit-table-box>
        <div class="footer">
            <lots-pagination
                @size-change="managerList.sizeChange"
                :current-page.sync="managerList.pageNo"
                @current-change="managerList.pageChange"
                layout="total, sizes, prev, pager, next, jumper"
                :total="managerList.pageTotal"
            />
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted, watch } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import store from '@/store';
import { formatDictCodeToName } from '@/modules/mdm/utils.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { getLocalCustomerManager, saveLocalCustomerManager, abandonLocalCustomerManager, authLocalCustomerManager } from '@mdm/api/customer/customerSeries.js';
import { tableConfig } from './config';

export default {
    name: 'localCustomerManager',
    components: {
        lotsButton,
        editTableBox,
        lotsPagination
    },
    props: {
        type: { // 用于区别是客户系详情还是客户详情
            type: String,
            default: () => ''
        },
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => {}
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        const { user } = store.getters;
        const hasAuth = ref(false);
        const tipText = ref('');
        const dictDatas = ref({});
        const rendertable = ref(1);
        const commonParams = ref({});

        class LocalCustomerManagerClass extends AdvanceListClass {
            beforeGetList(condition) {
                return { ...condition, ...commonParams.value };
            };
            afterGetList(res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        return {
                            edit: -3,
                            allowEdit: true,
                            ...v,
                            localManagerStatus: v.localManagerStatus?.toString()
                        }; ;
                    });
                    this.pageTotal.value = res.data.totalCount || 0;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox && setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }
        const managerList = new LocalCustomerManagerClass({
            Api: {
                listApi: getLocalCustomerManager
            }
        });
        // 查询是否有操作权限
        const handleAuth = async (customerGroupCode) => {
            const { data } = await authLocalCustomerManager({ userCode: user.userCode, customerGroupCode });
            hasAuth.value = data;
        };
        // 刷新表格
        const handleRendertable = () => {
            rendertable.value++;
            setupContext.root.$nextTick(() => {
                handleToBottom();
            });
        };
        // 新增
        const handleAdd = () => {
            managerList.totalData.value.unshift({
                edit: 2,
                allowEdit: true
            });
            const timer = setTimeout(() => { // 解决表格错位
                setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
            });
            timer && clearTimeout(timer);
        };
        // 表格内表单元素发生变化时回调
        const handleChangeRow = ({ prop, val, row }) => {
            if (prop === 'localManagerName') {
                if (val.selectList) {
                    row.localManagerCode = val.selectList[0].userCode;
                    row.localManagerName = val.selectList[0].userName;
                    row.localManagerStatus = '1';
                }
                handleRendertable();
            }
        };
        // 操作项
        const handleActive = (row, event) => {
            // 取消
            if (event === 'cancel') {
                handleRendertable();
            }
            // 保存
            if (event === 'save') {
                handleSave(row);
            }
            // 废弃
            if (event === 'abandon') {
                handleAbandon(row);
            }
        };
        // 保存
        const handleSave = async (row) => {
            const { code } = await saveLocalCustomerManager({ ...row, ...commonParams.value });
            if (+code === 0) {
                Message.success('保存成功');
                managerList.getList();
            }
        };
        // 废弃
        const handleAbandon = (row) => {
            MessageBox.confirm('废弃后不可恢复，是否继续废弃？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const { code } = await abandonLocalCustomerManager({ ...row, ...commonParams.value, idList: [row.id] });
                    if (+code === 0) {
                        Message.success('废弃成功');
                        managerList.getList();
                    }
                });
        };
        // 滚动到页面底部
        const handleToBottom = () => {
            const element = document.querySelector('.customer-series-manage-paper .customer-series-manage-tab-pane.el-tabs > .el-tabs__content > .el-tab-pane.detail-pane');
            element.scrollTop = element.scrollHeight;
        };
        onMounted(async () => {
            const { data } = await getDictDataApi({ dictCodes: 'LOCAL_MANAGER_STATUS' });
            dictDatas.value = data || {};
        });
        watch(
            () => [props.activeName, props.detailData, props.type],
            (val) => {
                managerList.totalData.value = [];
                managerList.pageTotal.value = 0;

                commonParams.value = {};
                tipText.value = '';
                // 客户系详情页面
                if (val[2] === 'customerSeries') {
                    // 传客户系编码
                    commonParams.value = { customerGroupCode: val[1].customerGroupCode };
                }

                // 客户详情页面
                if (val[2] === 'customerManage') {
                    if (val[1].customerGroupCode === '00') { // 客户系为其他
                        // 传客户编码
                        commonParams.value = { customerCode: val[1].customerCode };
                    } else if (val[1].customerGroupCode) { // 客户系为非其他
                        // 传客户系编码
                        commonParams.value = { customerGroupCode: val[1].customerGroupCode };
                        tipText.value = '请在客户系详情页维护属地客户经理';
                    }
                }

                if (val[0] === 'localCustomerManager' && val[1].customerGroupCode) {
                    managerList.getList();
                    handleAuth(val[1].customerGroupCode);
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            config,
            hasAuth,
            tipText,
            managerList,
            dictDatas,
            rendertable,
            formatDictCodeToName,
            handleAdd,
            handleChangeRow,
            handleActive,
            handleToBottom
        };
    }
};
</script>

<style lang="less" scoped>
.local-customer-manager-btn {
    width: 100%;
    display: flex;
    align-items: center;
}
.local-customer-manager-tip {
    padding-bottom: 8px;
    color: #888;
}
.footer {
    padding: 10px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
